import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import {
  capitalizeFirstLetter,
  formateDate,
  formateDateWithMonth,
  getFormatedTime,
  handleServerValidations,
  showStatus,
} from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import toHtml from "html-react-parser";

// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import {
  subscribeForPremium,
  subscriptionHistoryList,
  unsubscribeFromPremium,
  userDetails,
  userReportPdf,
} from "../../services/user.service";
import Swal from "sweetalert2";
import {
  SUBSCRIPTION_NAMES,
  SUBSCRIPTION_PRODUCT_IDS,
  SWAL_SETTINGS,
} from "../../../../utils/Constants";
import { SubscriptionHistoryList } from "../../services/subscriptionPlan.services";
import CustomRangepicker from "../../common/rangepicker";
import CustomPagination from "../../common/custompagination";
import { useDispatch } from "react-redux";
import { addUserData } from "../../../../redux/slices/userDetailsSlice";

const UserReportHistory = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useParams();
  const dispatch = useDispatch();

  const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
  const [reportList, setReportList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [activeTab, setActiveTab] = useState("details");
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [loader, setLoader] = useState(true);
  const [resetdate, setResetDate] = useState(false);

  useEffect(() => {
    setLoader(true);
    userReportPdf(params.id)
      .then((response) => {
        let d = new Date(response?.data?.date_of_birth) || new Date();
        const safeDate = new Date(
          d.getUTCFullYear(),
          d.getUTCMonth(),
          d.getUTCDate(),
        );
        response.data.date_of_birth = safeDate;

        console.log(params, "======+ID");
        console.log(response, "===========++>");

        setReportList(response?.data?.list || []);
        dispatch(addUserData(response?.data));
      })
      .catch((error) => {
        console.log("error=====>", error);
      })
      .finally(() => {
        setLoader(false);
      });
  }, [params.id, statsupdate]);

  return (
    <>
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div className="row mb-3">
                {loader ? (
                  <div className="col-12 text-center p-4">
                    <Loader />
                  </div>
                ) : reportList && reportList.length > 0 ? (
                  reportList.map((item, index) => (
                    <div className="col-lg-4" key={index}>
                      <div className="border rounded-2 p-3">
                        {/* Name and Badge */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h5 className="mb-0">
                            <strong>Name :</strong>{" "}
                            {item?.family_member?.nick_name
                              ? item.family_member.nick_name
                              : "Self"}
                          </h5>
                          {item?.family_member?.nick_name && (
                            <span className="badge bg-warning text-white">
                              Family Member
                            </span>
                          )}
                        </div>

                        {/* Date */}
                        <p className="mb-2">
                          <strong>Date :</strong>{" "}
                          {item?.createdAt
                            ? `${formateDate(item.createdAt)} ${getFormatedTime(item.createdAt)}`
                            : "N/A"}
                        </p>

                        {/* Report Title */}
                        <h5 className="mb-2">
                          {capitalizeFirstLetter(
                            (item?.report_slug || "Report").replace(/_/g, " "),
                          )}
                        </h5>

                        {/* Download Button */}
                        <div className="mt-3">
                          <a
                            href={`${BASE_URL}/uploads/downloaded_reports/${item?.report_pdf
                              ?.split("/")
                              .pop()}`}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-primary active rounded-2"
                          >
                            <i className="fa fa-download me-2"></i>
                            Download PDF Report
                          </a>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div class="card custom-card" style={{ backgroundColor: 'rgb(234, 237, 247)' }}>
                    <div class="card-body">
                      <div class="row row-sm">
                        <div class="d-flex justify-content-center">
                          <h4>No Report Found</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* Back Button */}
            <div className="mt-2 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() => navigate(-1)}
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserReportHistory;
